import * as angular from 'angular';

import * as Fields from '../../../common/helpers/contextual';
import { ComponentDefinition, PropertyType, ContextualField, AggregationMode } from '../../../models/';
import { ChartIdentifierWidgetConfiguration } from '../../../widgets/chartByIdentifier/chartByIdentifier.configuration';

class DoughnutChartWidgetContextualController implements angular.IComponentController {
    configuration: ChartIdentifierWidgetConfiguration;
    formController: angular.IFormController;
    isLoading: boolean;
    properties: ContextualField[];

    readonly cancel: () => void;
    readonly save: () => void;

    private _originalConfiguration: ChartIdentifierWidgetConfiguration;
    private _garbages: (() => void)[] = [];

    static $inject = ['$scope', '$q'];
    constructor(private _$scope: angular.IScope,
        private _$q: angular.IQService) {
    }

    $onInit() {
        if (!this.configuration.nameConfiguration) {
            this.configuration.nameConfiguration = {
                hasName: true,
                hasGroupName: false,
                hasShortComment: false,
                hasUnit: true,
                hasValueType: false
            };
        }
        this._originalConfiguration = angular.copy(this.configuration);
        this.initProperties();
    }

    $onDestroy() {
        this._garbages.forEach(g => g());
    }

    onSave(): angular.IPromise<void> {
        return this._$q.when(this.save());
    }

    onCancel() {
        this.configuration = angular.copy(this._originalConfiguration);
        this.cancel();
    }

    private initProperties() {
        const aggregationMode = angular.copy(Fields.AggregationMode);
        aggregationMode.isValid = (value: AggregationMode) => {
            return {
                'value':
                    value !== AggregationMode.None &&
                    value !== AggregationMode.Delta &&
                    value !== AggregationMode.Integration
            };
        };
        aggregationMode.messages = [
            {
                key: 'value',
                value: 'A valid aggregation mode must be selected.'
            }
        ];
        this.properties = [
            angular.copy(Fields.Title),
            angular.copy(Fields.IsTitleVisible),
            angular.copy(Fields.IsLegendVisible),
            angular.copy(Fields.Thickness),
            angular.copy(Fields.IsLabelsVisible),
            aggregationMode,
            angular.copy(Fields.MinPeriod),
            angular.copy(Fields.MaxPeriod),
            angular.copy(Fields.PeriodReference),
            angular.copy(Fields.IsEndDateIncluded),
            angular.copy(Fields.NameConfiguration.HasGroupName),
            angular.copy(Fields.NameConfiguration.HasName),
            angular.copy(Fields.NameConfiguration.HasShortComment),
            angular.copy(Fields.NameConfiguration.HasValueType),
            angular.copy(Fields.NameConfiguration.HasUnit),
            angular.copy(Fields.PresentationUnit),
            {
                modelName: 'orderBy',
                propertyType: PropertyType.Select,
                propertyName: 'orderByProperty',
                label: 'Order by',
                icon: 'fa-sort-amount-desc',
                extraData: {
                    subProperty: 'options',
                    options: [
                        {
                            key: 0,
                            value: 'By Series'
                        }, {
                            key: 1,
                            value: 'Largest to smallest'
                        }, {
                            key: 2,
                            value: 'Smallest to largest'
                        }
                    ]
                }
            }
        ];
    }
}

export const wtDoughnutChartWidgetContextual: ComponentDefinition = {
    componentId: 'wtDoughnutChartWidgetContextual',
    controller: DoughnutChartWidgetContextualController,
    template: require('./doughnutChartWidgetContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '=',
        configuration: '=',
        save: '&?',
        cancel: '&?'
    }
};